import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {Observable} from 'rxjs';
import {map, catchError} from 'rxjs/operators';

import {endpoints} from '../endpoints';

@Injectable({
  providedIn: 'root'
})
export class RegistroService {
  constructor(private http: HttpClient) {
  }

  getCatalogos(): Observable<any> {
    /**
     * Para consultar los catalogos de registro de usuario,
     * se declara la ruta con: const endpoint
     */
    return this.http.get(endpoints.registro.catalogos).pipe(map(results => {
      return results;
    }), catchError(error => {
      throw new Error(error.error.message);
    }));
  }

  crearUsuario(TIPO_PERSONA: string,
               nombre: string,
               apellido: string,
               telefono: string,
               TELEFONO_SECUNDARIO: string,
               correo: string,
               genero: string,
               tratamiento: number,
               dui: number,
               CARNET_RESIDENTE: string,
               CARNET_RESIDENTE_ARCHIVO: File,
               pasaporte: string,
               PASAPORTE_ARCHIVO: File): Observable<any> {
    /**
     * Para crear un nuevo usuario, se declara la ruta con: const endpoint
     * ademas de recibir los datos a crear en la funcion.
     */
    const formData = new FormData();
    formData.append('tipo_persona', TIPO_PERSONA);
    formData.append('nombre', nombre);
    formData.append('apellido', apellido);
    formData.append('telefono', telefono);
    if (TELEFONO_SECUNDARIO) {
      formData.append('telefono_secundario', TELEFONO_SECUNDARIO);
    }
    formData.append('correo', correo);
    formData.append('genero', genero);
    formData.append('tratamiento', tratamiento.toString());
    if (dui != null) {
      formData.append('dui', dui.toString());
      //formData.append('dui_archivo', DUI_ARCHIVO, DUI_ARCHIVO.name);
      //formData.append('nit', nit);
      //formData.append('nit_archivo', NIT_ARCHIVO, NIT_ARCHIVO.name);
    } else if (CARNET_RESIDENTE != null) {
      formData.append('pasaporte', pasaporte);
      formData.append('pasaporte_archivo', PASAPORTE_ARCHIVO, PASAPORTE_ARCHIVO.name);
      formData.append('carnet_residente', CARNET_RESIDENTE);
      formData.append('carnet_residente_archivo', CARNET_RESIDENTE_ARCHIVO, CARNET_RESIDENTE_ARCHIVO.name);
    } else {
      formData.append('pasaporte', pasaporte);
      formData.append('pasaporte_archivo', PASAPORTE_ARCHIVO, PASAPORTE_ARCHIVO.name);
    }
    return this.http.post(endpoints.registro.registrar, formData)
      .pipe(map(results => {
        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  validateLogInPortalEnLinea(user: string, pass: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    const parametros = {
      usuario: user,
      pass
    };

    return this.http.post(endpoints.registro.validatePel, JSON.stringify(parametros), {headers})
      .pipe(map((results: any) => {
        if (results.success) {
          if (results.data.code === 0) {
            //localStorage.setItem('at', results.data.access_token);
          }
        }
        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  confirmarLogInPortalEnLinea(parametros: any): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json'
      });

    return this.http.post(endpoints.registro.confirmarPel, JSON.stringify(parametros), {headers})
      .pipe(map((results: any) => {
        console.log('aber:?', results)
        if (results.success) {
          if (results.data.code === 0) {
            console.log('aber:?', results)
            //localStorage.setItem('at', results.data.access_token);
          }
        }
        return results;
      }), catchError(error => {
        throw new Error(error.error.message);
      }));
  }

  getInfoUser(document): Observable<any> {
    /**
     * Para consultar el endpoint de rnpn
     */
    return this.http.get(endpoints.registro.info_user + '/' + document).pipe(map(results => {
      return results;
    }), catchError(error => {
      throw new Error(error.error.message);
    }));
  }

   buscarPorDUI(dui: string): Observable<any> {
    return this.getInfoUser(dui);
  }
}
